import { getFormOptions } from "@/api/formoptions";
// http useable ports
export const httpUseablePorts = async () => {
    try {
        let result = await getFormOptions(`/useable-ports`);
        return result.data.httpReservePorts;
    } catch (err) {
        console.log(err);
    }
    return result;
};
// https useable ports
export const httpsUseablePorts = async () => {
    try {
        let result = await getFormOptions(`/useable-ports`);
        return result.data.httpsReservePorts;
    } catch (err) {
        console.log(err);
    }
    return result;
};
// origin useable ports
export const originUseablePorts = () => {
    let useablePorts = [];
    for (let x = 1; x < 65535; x++) {
        useablePorts.push(x);
    }
    return useablePorts;
};



// WEBPACK FOOTER //
// ./src/data/formOptions.js